import React from 'react';
import { UserPlusIcon, XIcon } from 'lucide-react';
interface BuddyRequestAlertProps {
  onDismiss: () => void;
  onAddBuddy: () => void;
}
const BuddyRequestAlert: React.FC<BuddyRequestAlertProps> = ({
  onDismiss,
  onAddBuddy
}) => {
  return <div className="glass-card p-4 relative mb-6" data-id="element-96">
      <button onClick={onDismiss} className="absolute top-2 right-2 text-purple-400 hover:text-purple-700" data-id="element-97">
        <XIcon size={16} data-id="element-98" />
      </button>
      <div className="flex items-start" data-id="element-99">
        <div className="flex-shrink-0 bg-purple-100 rounded-full p-2" data-id="element-100">
          <UserPlusIcon size={20} className="text-purple-600" data-id="element-101" />
        </div>
        <div className="ml-3" data-id="element-102">
          <h3 className="text-sm font-medium text-purple-900" data-id="element-103">
            Want help staying accountable?
          </h3>
          <p className="mt-1 text-sm text-purple-700" data-id="element-104">
            Add a support buddy to help you stay on track with your mentorship
            goals.
          </p>
          <button onClick={onAddBuddy} className="mt-2 text-sm font-medium text-purple-600 hover:text-purple-800 transition-colors" data-id="element-105">
            Add Support Buddy →
          </button>
        </div>
      </div>
    </div>;
};
export default BuddyRequestAlert;